import { SimpleForm, Create } from "react-admin";

import { CreateToolbar } from "../../common/CreateToolbar";
import { HomeSimpleFormContent } from "./components/HomeSimpleFormContent";

export function HomeCreate(): JSX.Element {
    return (
        <Create>
            <SimpleForm defaultValues={{ publicationDate: new Date() }} toolbar={<CreateToolbar />}>
                <HomeSimpleFormContent />
            </SimpleForm>
        </Create>
    );
}
